module.exports = __webpack_public_path__ + "static/img/android_yxz.79ee1c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android_yxz.png
// module id = DB2g
// module chunks = 2